// Web 主应用路由入口
// 注意此处变动，需要同步改动 @qn/route/index.tsx代码

import React, { lazy, Suspense, useEffect } from "react";
import { message, Modal } from "antd";
import copy from "copy-to-clipboard";
import { Route, Switch } from "react-router-dom";

import NotFound from "@/scenes/404";
import Home from "@/scenes/Home";
import HelpCenter from "@/scenes/HelpCenter";
import SubscriptionRoutes from "./SubscriptionRoutes";
import { AuthBaseRoutePath, CallbackBaseRoutePath, OMSBaseRoutePath, SubscriptionBaseRoutePath } from "./config";
import OMSRoutes from "./OMSRoutes";
const RefundRoutes = lazy(() => import("./RefundRoutes"));
import AuthRoutes from "./AuthRoutes";

const MoreFeaturesRoutes = lazy(() => import("./MoreFeaturesRoutes"));
const StockRoutes = lazy(() => import("./StockRoutes"));
const CustomizationRoutes = lazy(() => import("./CustomizationRoutes"));
const PartnershipRoutes = lazy(() => import("./PartnershipRoutes"));
const SettingRoutes = lazy(() => import("./SettingRoutes"));
const CallbackRoutes = lazy(() => import("./CallbackRoutes"));

function useWechatModalTip() {
    useEffect(() => {
        const isWechatBrowsers = window?.navigator?.userAgent?.toLowerCase()?.includes("micromessenger");

        if (isWechatBrowsers) {
            Modal.info({
                title: "提示",
                content: "请复制链接到浏览器内打开再使用，微信自带浏览器内订单加载和打单等都会变慢，请注意！",
                okText: "复制链接",
                closable: true,
                mask: { closable: false },
                onOk() {
                    copy(window.location.href);

                    message.success("复制成功");

                    return Promise.reject();
                },
            });
        }
    }, []);
}

interface SERouteProps {}

const SERoute: React.FC<SERouteProps> = function (props) {
    useWechatModalTip();

    return (
        <Suspense fallback="加载中...">
            <Switch>
                {/* 登录授权相关页面 */}
                <Route path={AuthBaseRoutePath} component={AuthRoutes} />

                {/* 回调路由页面 */}
                <Route path={CallbackBaseRoutePath} component={CallbackRoutes} />

                {/* 兼容千牛小程序的index.html路径 */}
                <Route exact path={["/", "/home", "/index.html"]} component={Home} />

                {/* 订单管理路由 */}
                <Route path={OMSBaseRoutePath} component={OMSRoutes} />
                <Route path="/refund" component={RefundRoutes} />

                {/* 来火定制相关业务路由 */}
                <Route component={CustomizationRoutes} path="/customization" />

                {/* 分销相关业务路由 */}
                <Route component={PartnershipRoutes} path="/partnership" />

                {/* 帮助 */}
                <Route exact path={["/helpCenter", "/cs"]} component={HelpCenter} />

                {/* 设置 */}
                <Route path="/setting" component={SettingRoutes} />

                {/* 备货拿货 */}
                <Route path="/stock" component={StockRoutes} />

                {/* 更多功能 */}
                <Route path="/features" component={MoreFeaturesRoutes} />

                {/* 店铺订购升级相关路由功能 */}
                <Route path={SubscriptionBaseRoutePath} component={SubscriptionRoutes} />

                <Route path="*" component={NotFound} />
            </Switch>
        </Suspense>
    );
};

export default React.memo(SERoute);
